let timer = null;

window.SendToast = function(type, title, msg, ms = 3000) {
	let icon = `<i class="fas fa-exclamation-triangle"></i>`
	if (type == 'success') {
		icon = `<i class="fas fa-check-circle"></i>`
	} else if (type == 'danger') {
		icon = `<i class="fas fa-exclamation-circle"></i>`
	}

	let toast = $(`
		<div class="toast alert-${type} ${type} shadow" role="alert" aria-live="assertive" aria-atomic="true">
			<div class="toast-header">
				<div class="toast-title">
					${icon}
					<strong>${title}</strong>
				</div>
			</div>
			<div class="toast-body">${msg}</div>
			<button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
		</div>
	`)

	$('.toast-bootstrap').append(toast)

	toast.toast({
		delay: ms
	})
	
	toast.toast('show')
}

window.SendToastBootstrap = function(type, title, msg, ms = 3000) {
	let headerClass = ``
	let icon = `<i class="fas fa-exclamation-triangle text-warning me-2 fs-5"></i>`
	if (type == 'success') {
		headerClass = ''
		icon = `<i class="fas fa-check-circle text-success me-2 fs-5"></i>`
	} else if (type == 'danger') {
		headerClass = ''
		icon = `<i class="fas fa-exclamation-circle text-danger me-2 fs-5"></i>`
	}

	let toast = $(`
		<div class="toast" role="alert" aria-live="assertive" aria-atomic="true">
			<div class="toast-header ${headerClass}">
				${icon}
        		<strong class="me-auto">${title}</strong>
        		<button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"><i class="fas fa-close"></i></button>
      		</div>
      		<div class="toast-body">${msg}</div>
    </div>`)
	
	$('.toast-container').append(toast)

	toast.toast({
		delay: ms
	})
	
	toast.toast('show')
}

window.InitRangeSlider = function(id, options) {
	return $(`${ id }`).slider(options)
}

window.addEventListener('flash_notification', event => {
	SendToast(event.detail.type, event.detail.title || '', event.detail.message)
})

window.addEventListener('toast_notification', event => {
	SendToastBootstrap(event.detail.type, event.detail.title || '', event.detail.message)
})

window.addEventListener('ecommerce_scripts_google', event => {
	gtag('event', 'add_to_cart', {
		'currency': "EUR",
  		'value': event.detail.product.price_vat,
		'items': [{
			item_id: event.detail.product.sku,
			item_name: event.detail.product.name,
			quantity: event.detail.quantity,
			item_brand: event.detail.brand,
			item_category: event.detail.category,
			price : event.detail.product.price_vat,
		}]
	});
})

window.addEventListener('ecommerce_scripts_google_conversion', event => {
	let send_to = event.detail.conv_id + event.detail.conv_id_complement;

	gtag('event', 'conversion', {
		'send_to':send_to,
		'currency': "EUR",
  		'value': event.detail.product.price_vat,
	});
})

window.addEventListener('ecommerce_scripts_google_remove_cart', event => {
	gtag('event', 'remove_from_cart', {
		'currency': "EUR",
  		'value': event.detail.product.price_vat,
		'items': [{
			item_id: event.detail.product.sku,
			item_name: event.detail.product.name,
			quantity: event.detail.quantity,
			item_brand: event.detail.brand,
			item_category: event.detail.category,
			price : event.detail.product.price_vat,
		}]
	});
})

window.addEventListener('ecommerce_scripts_fb', event => {
	fbq('track', 'AddToCart', {
		content_type: 'product',
		content_ids: [event.detail.product.sku],
		value: event.detail.product.price_vat,
		content_name : event.detail.product.name,
		currency: 'EUR',
		content_category: event.detail.category,
	});
})

var formatCurrency = function(value) {
	return new Intl.NumberFormat('pt-PT', { style: 'currency', currency: 'EUR' }).format(value)
}
window.formatCurrency = formatCurrency

Tabulator.extendModule("localize", "langs", {
	"pt":{
		"data":{
			"loading": "A carregar", //data loader text
			"error": "Erro", //data error text
		},
		"ajax":{
			"loading": "A carregar'", //data loader text
			"error": "Erro", //data error text
		},
		"pagination":{
			"page_size": "Registos por página", //label for the page size select element
			"page_title": "Página",//tooltip text for the numeric page button, appears in front of the page number (eg. "Show Page" will result in a tool tip of "Show Page 1" on the page 1 button)
			"first": "Primeira", //text for the first page button
			"first_title": "Primeira página", //tooltip text for the first page button
			"last": "Última",
			"last_title": "Última página",
			"prev": "Anterior",
			"prev_title": "Página anterior",
			"next": "Próxima",
			"next_title": "Próxima página",
			"all": "Todas",
			"counter": {
				"showing": "A mostrar",
				"of": "de",
				"rows": "registos",
				"pages": "páginas",
			}
		}
	}
})

Tabulator.extendModule("format", "formatters", {
	currency: function(cell, formatterParams){
		if (isNaN(cell.getValue())) {
			return '';
		} else {
        	return window.formatCurrency(cell.getValue())
		}
    },
});

$(function() {
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    //getCarrinhoItems();

    //Botão de fechar a popup do carrinho
    $('#close-cart').on('click',function() {
        toggleCart();
    });
    
    //Quando se passa o rato por cima do carrinho
    $('.header-cart-btn').on('click',function(event) {
        event.stopPropagation();
        openCart();
    });

    //Quando se clica fora da popup do carinho
    $(window).on('click',function() {
        $('#cart').hide();
        $('#overlay-cart').hide();
    });
    
	$('.filter-form input[type=checkbox]').on('change', function(e) {
		if (timer !== null) {
			//console.log('cleared timeout')
			clearTimeout(timer)
			timer = null
		}

		timer = setTimeout(function() {
			$('.filter-form').submit()
		}, 1000)
	})

	$(document).on('change', '.radio-checkout-input', function(e) {
		$('.radio-checkout-label').removeClass('is-invalid')
	})

	$(document).on('change', '.radio-checkout-input', function(e) {
		$('.radio-checkout-label').removeClass('is-invalid')
	})

	$(document).on('change', 'input[name="shippingAddress[id]"]', function(e) {
		if ($(this).val() == 'new-address') {
			$('.new-shipping-addr-btn').hide()
			$('.checkout-details-personal-wrapper').removeClass('d-none').addClass('selected')
			$('.vet-shipping').removeClass('d-none').addClass('selected')
		} else {
			$('.new-shipping-addr-btn').show()
			$('.checkout-details-personal-wrapper').addClass('d-none').removeClass('selected')
			$('.vet-shipping').addClass('d-none').removeClass('selected')
		}

		$('input[name="shippingAddress[shipping-nif]"]').prop('value', '');
		$('input[name="shippingAddress[firstname]"]').prop('value', '');
		$('input[name="shippingAddress[lastname]"]').prop('value', '');
		$('input[name="shippingAddress[phone]"]').prop('value', '');
		$('input[name="shippingAddress[nif]"]').prop('value', '');
		$('input[name="shippingAddress[country_id]"]').prop('value', '');
		$('input[name="shippingAddress[address]"]').prop('value', '');
		$('input[name="shippingAddress[postalcode]"]').prop('value', '');
		$('input[name="shippingAddress[city]"]').prop('value', '');
	})

	$(document).on('change', 'input[name="billpayer[id]"]', function(e) {
		if ($(this).val() == 'new-address') {
			$('.new-billing-addr-btn').hide()
			$('.checkout-details-personal-wrapper').removeClass('d-none').addClass('selected')
			$('.vet-billing').removeClass('d-none').addClass('selected')
		} else {
			$('.new-billing-addr-btn').show()
			$('.checkout-details-personal-wrapper').addClass('d-none').removeClass('selected')
			$('.vet-billing').addClass('d-none').removeClass('selected')
		}

		$('input[name="billpayer[shipping-nif]"]').prop('value', '');
		$('input[name="billpayer[firstname]"]').prop('value', '');
		$('input[name="billpayer[lastname]"]').prop('value', '');
		$('input[name="billpayer[phone]"]').prop('value', '');
		$('input[name="billpayer[nif]"]').prop('value', '');
		$('input[name="billpayer[country_id]"]').prop('value', '');
		$('input[name="billpayer[address]"]').prop('value', '');
		$('input[name="billpayer[postalcode]"]').prop('value', '');
		$('input[name="billpayer[city]"]').prop('value', '');

	})

	$(document).on('change', 'input[name="shipping[id]"]', function(e) {
		let price = parseFloat($(this).parent().find('.radio-checkout-price-value').data('price'))
		let total = parseFloat($('.summary-checkout-total-val').data('total'))

		if (price && price > 0) {
			$('.summary-checkout-total-val > span').text(FormatPrice((total + price).toFixed(2)))
			$('.summary-checkout-shipping-val > span').text(FormatPrice((price).toFixed(2)))
			$('.summary-checkout-shipping-val').html(`${ $('.summary-checkout-shipping-val').data('currency') } <span>${ FormatPrice((price).toFixed(2)) }</span>`)
		} else {
			$('.summary-checkout-total-val > span').text(FormatPrice(parseFloat(total).toFixed(2)))
			$('.summary-checkout-shipping-val').html(`<span>${ $('.summary-checkout-shipping-val').data('no-cost-label') }</span>`)
		}

		if ($('.summary-checkout-shipping-wrapper').hasClass('d-none')) {
			$('.summary-checkout-shipping-wrapper').removeClass('d-none')
		}

		$(`.checkout-store-pickup`).addClass('d-none');
		$(`.checkout-pickup`).addClass('d-none');
		
		if ($(this).data('pickup') == 1) {
			$(`.checkout-store-pickup.method-${$(this).val()}`).removeClass('d-none');
		} else {
			$('input[name="store[id]"]').prop('checked', false);
			$('input[name="pickup[id]"]').prop('checked', false);
			$('input[name="pickup_point"]').prop('value', '')
		}

		if($(this).data('pickup_method') == 1){
			$(`.checkout-pickup.method-${$(this).val()}`).removeClass('d-none');
		}
	}) 
	$(document).on('change', 'input[name="payment[id]"]', function(e) {
		$('input[name="mbway_phone"]').prop('value', '')

		let price = parseFloat($(this).parent().find('.radio-checkout-price-value').data('price'))
		let total = parseFloat($('.summary-checkout-total-val').data('total'))

		if (price && price > 0) {
			$('.summary-checkout-total-val > span').text(FormatPrice((total + price).toFixed(2)))
			$('.summary-checkout-payment-val > span').text(FormatPrice((price).toFixed(2)))
			$('.summary-checkout-payment-val').html(`${ $('.summary-checkout-payment-val').data('currency') } <span>${ FormatPrice((price).toFixed(2)) }</span>`)
		} else {
			$('.summary-checkout-total-val > span').text(FormatPrice(parseFloat(total).toFixed(2)))
			$('.summary-checkout-payment-val').html(`<span>${ $('.summary-checkout-payment-val').data('no-cost-label') }</span>`)
		}

		if ($('.summary-checkout-payment-wrapper').hasClass('d-none')) {
			$('.summary-checkout-payment-wrapper').removeClass('d-none')
		}
	})

	$(document).on('change', 'input[name="paymentCard[id]"]', function(e) {
		let price = parseFloat($(this).parent().find('.radio-checkout-price-value').data('price'))
		let total = parseFloat($('.summary-checkout-total-val').data('total'))

		if($(this).is(":checked")){
			if (price && price > 0) {
				let priceF = total - price;

				if(0 > priceF){
					$('.summary-checkout-total-card-wrapper').removeClass('d-none');
					$('.summary-checkout-total-card-val > span').text(FormatPrice(parseFloat(0).toFixed(2)))
					$('.summary-checkout-client-card-val > span').text(FormatPrice((total).toFixed(2)))
					$('.summary-checkout-client-card-val').html(`${ $('.summary-checkout-client-card-val').data('currency') } <span>-${ FormatPrice((total).toFixed(2)) }</span>`)
					$('.card-value-remaind-info').removeClass('d-none');
					$('.card-value-remaind').text(FormatPrice(parseFloat(Math.abs(priceF)).toFixed(2))+"€")
					$('.paymentDiv').addClass('d-none')
					if ($('.summary-checkout-client-card-wrapper').hasClass('d-none')) {
						$('.summary-checkout-client-card-wrapper').removeClass('d-none')
					}
				}else{
					$('.summary-checkout-total-card-wrapper').removeClass('d-none');
					if ($('.summary-checkout-client-card-wrapper').hasClass('d-none')) {
						$('.summary-checkout-client-card-wrapper').removeClass('d-none')
					}
					if ($('.summary-checkout-client-card-wrapper').hasClass('d-none')) {
						$('.summary-checkout-client-card-wrapper').removeClass('d-none')
					}
					$('.summary-checkout-total-card-val > span').text(FormatPrice(parseFloat(total - price).toFixed(2)))
					$('.summary-checkout-client-card-val > span').text(FormatPrice((price).toFixed(2)))
					$('.summary-checkout-client-card-val').html(`${ $('.summary-checkout-client-card-val').data('currency') } <span>-${ FormatPrice((price).toFixed(2)) }</span>`)
					$('.card-value-remaind-info').removeClass('d-none');
					$('.card-value-remaind').text(FormatPrice(parseFloat(0).toFixed(2))+"€")
				}
			}else{
				if ($('.paymentDiv').hasClass('d-none')) {
					$('.paymentDiv').removeClass('d-none')
				}

				if ($('.summary-checkout-client-card-wrapper').hasClass('d-none')) {
					$('.summary-checkout-client-card-wrapper').removeClass('d-none')
				}
				
				$('.summary-checkout-total-card-val > span').text(FormatPrice(parseFloat(total).toFixed(2)))
			}
		}else{
			if ($('.paymentDiv').hasClass('d-none')) {
				$('.paymentDiv').removeClass('d-none')
			}

			if ($('.summary-checkout-client-card-wrapper').hasClass('d-none')) {
				$('.summary-checkout-client-card-wrapper').removeClass('d-none')
			}else{
				$('.summary-checkout-client-card-wrapper').addClass('d-none')
			}
			$('.summary-checkout-total-val > span').text(FormatPrice(parseFloat(total).toFixed(2)))
			$('.card-value-remaind-info').addClass('d-none')
			$('.summary-checkout-total-card-wrapper').addClass('d-none');
			$('.card-value-remaind').text('')
		}
	})

	function FormatPrice(price, decimals = 2, decimal_separator = ',', $thousands_separator = '.') {
		return new Intl.NumberFormat('pt-PT', { style: 'decimal', minimumFractionDigits: '2', maximumFractionDigits: '2' }).format(price)
	}

	function ShowBillingFields() {
		$('input[name="billpayer[firstname]"]').val('')
		$('input[name="billpayer[firstname]"]').show()
		$('input[name="billpayer[lastname]"]').val('')
		$('input[name="billpayer[lastname]"]').show()
		$('input[name="billpayer[lastname]"]').parent().show()
		$('input[name="billpayer[telefone]"]').val('')
		$('input[name="billpayer[telefone]"]').show()
		$('input[name="billpayer[address][address]"]').val('')
		$('input[name="billpayer[address][address]"]').show()
		$('input[name="billpayer[address][address]"]').parent().show()
		$('input[name="billpayer[address][city]"]').val('')
		$('input[name="billpayer[address][city]"]').show()
		$('input[name="billpayer[address][city]"]').parent().show()
		$('input[name="billpayer[address][postalcode]"]').val('')
		$('input[name="billpayer[address][postalcode]"]').show()
		$('select[name="billpayer[address][country_id]"]').val('')
		$('select[name="billpayer[address][country_id]"]').show()
		$('input[name="billpayer[address][postalcode]"]').parent().show()
	}

	function HideBillingFields() {
		$('input[name="billpayer[firstname]"]').val('')
		$('input[name="billpayer[firstname]"]').hide()
		$('input[name="billpayer[lastname]"]').val('')
		$('input[name="billpayer[lastname]"]').hide()
		$('input[name="billpayer[lastname]"]').parent().hide()
		$('input[name="billpayer[telefone]"]').val('')
		$('input[name="billpayer[telefone]"]').hide()
		$('input[name="billpayer[address][address]"]').val('')
		$('input[name="billpayer[address][address]"]').hide()
		$('input[name="billpayer[address][address]"]').parent().hide()
		$('input[name="billpayer[address][city]"]').val('')
		$('input[name="billpayer[address][city]"]').hide()
		$('input[name="billpayer[address][city]"]').parent().hide()
		$('input[name="billpayer[address][postalcode]"]').val('')
		$('input[name="billpayer[address][postalcode]"]').hide()
		$('select[name="billpayer[address][country_id]"]').val('')
		$('select[name="billpayer[address][country_id]"]').hide()
		$('input[name="billpayer[address][postalcode]"]').parent().hide()
	}

    $(document).on('change','.filter-list-item .custom-control-input',function(e){
        
        var checked = $(this).prop("checked")
        if($(this).prop('name') == "category[]"){
            container = $(this).parent().parent().parent(),
            siblings = container.siblings('ul');

            container.find('input[type="checkbox"]').prop({
                indeterminate: false,
                checked: checked
            });

            container.find('input[type="hidden"]').prop('disabled',true);

            function checkSiblings(el) {
                var parent = el.parent(),
                all = true;

                el.siblings('ul').each(function() {
                    let returnValue = all = ($(this).children().children().children('input[type="checkbox"]').prop("checked") === checked);
                    return returnValue;
                });

                if (all && checked) {
                    parent.children().children('input[type="checkbox"]').prop({
                        indeterminate: false,
                        checked: checked
                    });

                    parent.children().children('input[type="hidden"]').prop('disabled',true);
            
                    checkSiblings(parent);

                } else if (all && !checked) {
                    parent.children().children('input[type="checkbox"]').prop("checked", checked);
                    parent.children().children('input[type="checkbox"]').prop("indeterminate", (parent.find('input[type="checkbox"]:checked').length > 0));
                    if(parent.find('input[type="checkbox"]:checked').length > 0){
                        parent.children().children('input[type="hidden"]').prop('disabled',false);
                    }else{
                        parent.children().children('input[type="hidden"]').prop('disabled',true);
                    }
                } else { 
                    el.parents("li").children().children('input[type="checkbox"]').prop({
                        indeterminate: true,
                        checked: false
                    });

                    el.parents("li").children().children('input[type="hidden"]').prop('disabled',false);
                }
            }

            checkSiblings(container);
        
        }
       
    })

	$(document).on('submit', '#final-checkout-form', function(e) {
		$('.finish-checkout').prop('disabled', true)
	})

	$(document).on('click','#cookieBoxBtn',function(e){
		setCookie('acccookies','accept',7);
		$('#cookieBox').removeClass("showcookie"); 
		$('#cookieBox').addClass("hidecookie");
	});

	$(document).on('submit', 'form', function(e) {
		e.preventDefault()
		let form = $(this)[0]
		let ctitle = $(this).data('confirmation-title')
		let ctext = $(this).data('confirmation-text')
		if (ctext) {
			if (ctitle) {
				$('#confirmation-modal-frontoffice .modal-title').html(ctitle)
			}
			$('#confirmation-modal-frontoffice .modal-body').html(ctext)

			let modal = bootstrap.Modal.getOrCreateInstance('#confirmation-modal-frontoffice')
			$('#confirmation-modal-frontoffice').on('hidden.bs.modal', function () {
				modal.dispose()
			})
			$('#confirmation-modal-frontoffice #modal-confirm').on('click', function() {
				modal.hide()
				form.submit()
			})
			modal.show()
		} else {
			form.submit()
		}
	})

	document.querySelectorAll('img.svg-icon').forEach(img => {
		if (!img.hasAttribute('alt')) {
			img.setAttribute('alt', 'Icon'); // Replace 'Icon' with a more descriptive text if needed
		}
	});
});

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}